import { createRouter, createWebHistory } from 'vue-router'
import routes from "./routes"
import beforeEachRoute from "./beforeEachRoute"
import store from '@/store/BookingStore'
import afterEachRoute from './afterEachRoute'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL || window.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            resolve({ left: 0, top: 0 })
        })
    }
})

router.beforeEach(beforeEachRoute)
router.afterEach(afterEachRoute)

export default router